export default function Toggle({ on, onClick, label }) {
  return (
    <button type="button" className="lb-toggle" onClick={onClick} style={{ background: 'transparent', border: 0, padding: 0 }}>
      <span className={'lb-toggle__track ' + (on ? 'lb-toggle__track--on' : 'lb-toggle__track--off')}>
        <span className={'lb-toggle__knob ' + (on ? 'lb-toggle__knob--on' : 'lb-toggle__knob--off')} />
      </span>
      {label && <span style={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: 12, letterSpacing: '0.06em', color: on ? '#fff' : 'var(--ink-600)' }}>{label}</span>}
    </button>
  );
}
